module.exports = __webpack_public_path__ + "images/common/bg_item_watch_recommendation_d1a5473fd575009263765d7d3b8d9aec.png";